import { Button, Intent, NonIdealState } from '@blueprintjs/core'
import * as React from 'react'
import { IconNames } from '@blueprintjs/icons'
import { EventLogTimeline } from '../EventLogTimeline'
import Widget from '../Widget'
import { EventLog } from '../../types/api'
import { UprightStyle } from '../../types'

export interface Props {
  eventLogs: EventLog[]
}

const styles: UprightStyle = {
  contentStyle: { paddingTop: 0, paddingBottom: 10 }
}

export const EventLogWidget: React.FC<Props> = props => {
  const [isCollapsed, setCollapsed] = React.useState(true)
  const eventLogsMissing = !props.eventLogs || !props.eventLogs.some(log => log.message)

  return (
    <Widget title="Events" contentStyle={styles.contentStyle}>
      {eventLogsMissing ? (
        <NonIdealState icon={IconNames.TIMELINE_EVENTS} title="No events" />
      ) : (
        <div>
          <EventLogTimeline eventLogs={props.eventLogs} collapsed={isCollapsed} style={styles.eventLogTimeline} />
          {props.eventLogs.length > 5 && (
            <Button
              text={isCollapsed ? 'Show more...' : 'Show less'}
              minimal
              intent={Intent.PRIMARY}
              onClick={() => setCollapsed(!isCollapsed)}
              data-testid="event-log-widget-toggle-more-button"
            />
          )}
        </div>
      )}
    </Widget>
  )
}
